const frenchExcludedPages = [
    "/services",
    "/catalogue",
    "/signin",
    "/careers",
    "/accessibility-statement",
    "/resources",
    "/catalog/brick-selector",
    "/feature-projects",
    "/recalls",
];

export const isPageExcludedFromFrench = (pathname: string): boolean => {
    const currentPath = pathname.toLowerCase();
    return frenchExcludedPages.some(p => currentPath.startsWith(p.toLowerCase()));
};